import { createSelector } from 'reselect';
import { scienceContestsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const scienceContestsYearsSelector = createSelector([scienceContestsSelector], (scienceContests) =>
  extractDatesFromNestedItems(
    [scienceContests.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
